import { UserRole } from 'components/user/user-role/UserRole'
import { useFetch } from 'services/useFetch'
import { API_USER_ROLE } from 'services/apiUserRole'
import { useEffect, useState } from 'react'
import { Alert } from 'avo-ui'

export const UserRoleContainer = () => {
    const [reload, setReload] = useState(false)
    const [deleteId, setDeleteId] = useState(null)
    const [showModalDelete, setShowModalDelete] = useState(false)
    const { fetching: getUserRoleList, data: userRoleList, isLoading } = useFetch(API_USER_ROLE.LIST)
    const { fetching: deleteRole, isLoading: isDeleting } = useFetch(API_USER_ROLE.DELETE)

    useEffect(() => {
        getUserRoleList()
    }, [reload])

    const setShowModalDeleteHandler = (id, value) => {
        setDeleteId(id)
        setShowModalDelete(value)
    }

    const onDelete = () => {
        deleteRole({}, deleteId).then(() => {
            setShowModalDeleteHandler(null, false)
            setReload(!reload)
            return Alert({
                icon: 'success',
                title: 'Success',
                message: 'User Role Deleted !',
            })
        })
    }

    const props = {
        dataList: userRoleList?.data,
        showModalDelete,
        setShowModalDeleteHandler,
        onDelete,
        isLoading,
        isDeleting,
    }

    return <UserRole {...props} />
}
